<template>
  <div class="link-list-accordions">
    <div 
      class="link-list-accordion"
      v-for="(list, i) in lists"
      :key="i"
      :id="uID(i)"
    >
      <button 
        :id="uID(i)"
        @click="toggleAccordion(uID(i))"
        :class="{ active : open === uID(i) }"
      >
        {{ list.header.name }}
        <i class="far fa-chevron-down" aria-hidden></i>
      </button>
      <transition name="slide">
        <LinkList 
          :links="links(list.header, list.links)" 
          :unstyle="true" 
          :aria-labelledby="uID(i)"
          v-if="open === uID(i)"
        />
      </transition>
    </div>
  </div>
</template>

<script>
  import LinkList from './LinkList.vue'

  export default {
    name: 'LinkListAccordion',
    props: {
      lists: Array,
      addHeaderToLinks: Boolean
    },
    data() {
      return {
        open: '',
      }
    },
    components: {
      LinkList
    },
    methods: {
      toggleAccordion(accordion) {
        this.open = (this.open === accordion) ? '' : accordion
      },
      uID(index) {
        return 'link-list-accordion' + index
      },
      links(header, list) {
        if (this.addHeaderToLinks && header.url) {
          let link = {...header}
              link.name = 'All ' + link.name
              link.title = 'All ' + link.title
              link.link = 'All ' + link.link
          return [link, ...list]
        } else {
          return list
        }
      }
    },
  }
</script>

<style lang="scss">
  .link-list-accordion {
    border-bottom: 1px solid #ccc;

    button {
      background: #fff;
      width: 100%;
      text-align: left;
      display: grid;
      grid-template-columns: 1fr 10px;
      align-items: center;
      padding: 15px 20px;
      border: 0px;

      &.active .fa-chevron-down {
        transform: rotate(180deg);
      }
    }

    a {
      padding: 10px 10px 10px 35px;
      width: 100%;
      display: block;
      color: #000;
    }

    .slide-enter-active {
      transition-duration: 1s;
    }
    .slide-leave-active {
      transition-duration: .2s;
    }
    .slide-enter-to, .slide-leave {
      max-height: 1000px;
      overflow: hidden;
    }
    .slide-enter, .slide-leave-to {
      overflow: hidden;
      max-height: 0;
    }
  }
</style>
